import { TabPanel, TabView } from "primereact/tabview";
import constantes from "../../catalogos/constantes"
import useSeguridad from "../../Seguridad/useSeguridad"
import useSessionState from "../../hooks/useSessionState";
import SolicitudVacantes from "./solicitudVacantes";
const SolicitudVacantesSecciones = ()=>{
    const seguridad = useSeguridad();
    const soloLectura = !seguridad.esEditable(constantes.menus.solicituVacante);
    const [activeIndex, setActiveIndex] = useSessionState('tabSeguimiento', 0);

    return (
        <>
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="main-tab-view">
          <TabPanel  headerStyle ={(seguridad.tieneAcceso(constantes.menus.solicitudVacanteSeccion) || soloLectura )?  {display:"inline"} : {display:"none"} } header="Solicitud de Vacantes">
                <SolicitudVacantes esSeccionAutorizar={false} soloLectura={soloLectura} />
            </TabPanel>
            <TabPanel  headerStyle ={seguridad.tieneAcceso(constantes.menus.solicitudVacantePorAutorizar) ?  {display:"inline"} : {display:"none"} } header="Solicitud de Vacantes por Autorizar">
                <SolicitudVacantes esSeccionAutorizar={true} soloLectura={soloLectura}/>
            </TabPanel>
        </TabView>
        </>
    )
};
export default SolicitudVacantesSecciones;